import { render, staticRenderFns } from "./AndamentoDocs.vue?vue&type=template&id=fef28e38&scoped=true"
import script from "./AndamentoDocs.vue?vue&type=script&lang=js"
export * from "./AndamentoDocs.vue?vue&type=script&lang=js"
import style0 from "./AndamentoDocs.vue?vue&type=style&index=0&id=fef28e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef28e38",
  null
  
)

export default component.exports